placeholder for manage licenses